import React from 'react'
import styles from './styles.module.scss'

const NotFoundDisclosure = () => <span className={styles.error}>DISCLOSURE NOT FOUND</span>

export default NotFoundDisclosure
